import styled from 'styled-components';

export const Container = styled.div`
  button {
    margin-bottom: 0.5rem;
  }
`;
